"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CycleCount = void 0;
const router_1 = require("client/components/router");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/stocks/store");
const store_4 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
const edit_cycle_count_1 = require("../../components/edit-cycle-count");
const edit_cycle_count_review_1 = require("../../components/edit-cycle-count/components/edit-cycle-count-review");
require("./cycle-count.less");
let CycleCount = class CycleCount extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showCycleCountReview = false;
        this.siteInventoryCycleCountAndActualQuantity = new Map();
        this.initializeCycleCountAndActualQuantity = () => {
            //
            const { inventory: { value = [] } } = store_1.inventoryListStore;
            this.siteInventoryCycleCountAndActualQuantity.clear();
            // Formulate cycle count data
            for (const group of value) {
                if (group && group.children && group.children.length) {
                    for (const child of group.children) {
                        // initialize actual quantity.
                        const inventorySite = child.sites.find(site => site.siteId === Number(this.props.params[0]));
                        const { quantity = 0 } = inventorySite || {};
                        const cycleCountAndActualQuantity = {
                            handCount: this.siteInventoryCycleCount
                                ? this.siteInventoryCycleCount.get(child.id)
                                : 0,
                            actualCount: quantity || 0
                        };
                        this.siteInventoryCycleCountAndActualQuantity.set(child.id, cycleCountAndActualQuantity);
                    }
                }
            }
        };
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo("/lots/pharmacies");
        };
        this.handleReviewCancel = () => {
            this.showCycleCountReview = false;
        };
        this.handleCancelReviewCycleCount = () => {
            console.log("handlecancelreviewcyclecount");
        };
        this.handleSave = async (site, siteInventoryCycleCount) => {
            this.siteInventoryCycleCount = siteInventoryCycleCount;
            this.initializeCycleCountAndActualQuantity();
            // Save initial on hand and actual count and return cycle count header id to update
            // in cycle count review submit.
            const cycleCountInventories = [];
            for (const [key, value] of this.siteInventoryCycleCountAndActualQuantity) {
                const cycleCountInventory = {
                    inventoryId: key,
                    qtyDifference: Math.abs(value.actualCount - value.handCount),
                    blindCountQty: value.handCount,
                    actualCountQty: value.actualCount
                };
                cycleCountInventories.push(cycleCountInventory);
            }
            await store_3.stocksStore.submitInitial(site, cycleCountInventories);
            // Get cycle count header to pass to review component
            this.cycleCountSavedInitial = store_3.stocksStore.cycleCountSavedInitial;
            this.showCycleCountReview = true;
            console.log("this.cycleCountSavedInitial is ", this.cycleCountSavedInitial);
        };
        this.getNextCycleCountCountDown = () => {
            const lastCycleCount = store_3.stocksStore.latestCycleCount;
            // if todays date is before 15 of month,
            // figure out the difference in day until 15th of current month
            // if todays date is after 15 of month,
            // figure out the difference in day until 15th of next month
            const fifteenthOfMonth = moment()
                .startOf("month")
                .add(14, "days")
                .format("YYYY-MM-DD hh:mm:ss A");
            const fifteenthOfNextMonth = moment()
                .startOf("month")
                .add(1, "month")
                .add(14, "days")
                .format("YYYY-MM-DD hh:mm:ss A");
            const lastCycleCountDate = moment(new Date(lastCycleCount ? lastCycleCount.createdAt : "")).format("YYYY-MM-DD hh:mm:ss A");
            const today = moment(new Date()).format("YYYY-MM-DD hh:mm:ss A");
            let nextCycleCountCountDown;
            const currentDateBeforeFifteenthOfMonth = moment(today).isBefore(fifteenthOfMonth);
            if (currentDateBeforeFifteenthOfMonth) {
                nextCycleCountCountDown = moment(fifteenthOfMonth).diff(moment(today), "days");
            }
            else {
                nextCycleCountCountDown = moment(fifteenthOfNextMonth).diff(moment(today), "days");
            }
            return nextCycleCountCountDown;
        };
        this.handleReviewSave = async (site, cycleCountInventories) => {
            console.log("inside handleReviewSave");
            await store_3.stocksStore.submit(site, this.cycleCountSavedInitial, cycleCountInventories);
            this.showCycleCountReview = false;
        };
    }
    componentWillMount() {
        // inventoryListStore.loadInventory();
        // const options = {
        //   count: 100,
        //   start: 0,
        //   where: this.props.params
        //     ? `inventorysite.siteId = ${this.props.params[0]}`
        //     : ""
        // };
        // inventoryListStore.loadInventory(options);
    }
    async componentDidMount() {
        const siteId = this.props.params[0];
        if (siteId) {
            await store_3.stocksStore.readLatestCycleCount(siteId);
        }
    }
    *renderHeader() {
        const { firstName, lastName, site } = store_4.usersStore.user.value && store_4.usersStore.user.value;
        const lastCycleCountDate = store_3.stocksStore.latestCycleCount
            ? moment(store_3.stocksStore.latestCycleCount.createdAt).format("MM-DD-YYYY")
            : "";
        const nextCycleCountCountDown = this.getNextCycleCountCountDown();
        yield (React.createElement("div", { className: "cycle-count", key: "qty-overview" },
            React.createElement("div", null,
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "display1" }, "Cycle Count"),
                React.createElement("div", { className: "cycle-count__schedule cycle-count__schedule--label" },
                    React.createElement(material_ui_1.Typography, { className: "cycle-count__schedule--last", color: "inherit", variant: "subheading" }, "Last"),
                    React.createElement(material_ui_1.Typography, { className: "cycle-count__schedule--next", color: "inherit", variant: "subheading" }, "Next")),
                React.createElement("div", { className: "cycle-count__schedule" },
                    React.createElement(material_ui_1.Typography, { className: "cycle-count__schedule--last", color: "inherit", variant: "body1" }, lastCycleCountDate || "n/a"),
                    React.createElement(material_ui_1.Typography, { className: "cycle-count__schedule--next", color: "inherit", variant: "subheading" }, `${nextCycleCountCountDown} days`))),
            React.createElement("div", { className: "cycle-count__user-site" },
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "subheading" },
                    "User: ",
                    `${firstName} ${lastName}`),
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "subheading" },
                    "Pharmacy: ",
                    site ? site.displayName || site.name : "Site not found"),
                React.createElement(material_ui_1.Typography, { color: "inherit", variant: "subheading" },
                    "Date: ",
                    moment(new Date()).format("MM-DD-YYYY")))));
    }
    render() {
        return (React.createElement("div", { className: "sites__form" }, store_4.usersStore.permissions.ReadCycle ? (React.createElement(React.Fragment, null,
            [...this.renderHeader()],
            !this.showCycleCountReview && (React.createElement(edit_cycle_count_1.EditCycleCount, { error: store_2.sitesDetailStore.inventorysites.error, loading: store_2.sitesDetailStore.site.loading, status: store_2.sitesDetailStore.site.status, onCancel: this.handleCancel, onSave: this.handleSave, site: store_2.sitesDetailStore.site.value })),
            this.showCycleCountReview && (React.createElement(edit_cycle_count_review_1.EditCycleCountReview, { error: store_2.sitesDetailStore.inventorysites.error, loading: store_2.sitesDetailStore.site.loading, status: store_2.sitesDetailStore.site.status, onCancel: this.handleReviewCancel, onSave: this.handleReviewSave, 
                // cycleCountHeader={this.cycleCountSavedInitial}
                site: store_2.sitesDetailStore.site.value, siteInventoryCycleCount: this.siteInventoryCycleCount })))) : (store_4.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], CycleCount.prototype, "showCycleCountReview", void 0);
__decorate([
    mobx_1.observable
], CycleCount.prototype, "siteInventoryCycleCount", void 0);
__decorate([
    mobx_1.observable
], CycleCount.prototype, "siteInventoryCycleCountAndActualQuantity", void 0);
__decorate([
    mobx_1.observable
], CycleCount.prototype, "cycleCountSavedInitial", void 0);
CycleCount = __decorate([
    mobx_react_1.observer
], CycleCount);
exports.CycleCount = CycleCount;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/tabs/cycle-count/cycle-count.tsx
// module id = 4097
// module chunks = 0